export const setLastCostCentreInStorage = costCentre => {
  if (costCentre) {
    sessionStorage.setItem("costCentre", JSON.stringify(costCentre));
  }
};

export const getLastCostCentreFromStorage = () => {
  const costCentre = sessionStorage.getItem("costCentre");
  if (!costCentre) return undefined;
  return JSON.parse(costCentre);
};
